const useSharableState = () => {
  // CONTRACT ADDRESS
  const JTOKENAddress = "0xe56f00bE5cdC3dF68cFeA8D203f189bc23ADec7f";
  const RANDOMNFTAddress = "0x6438be90ABed72b70eee8360332537E3b0D21dDD";
  const MarketPlaceAddress = "0x8e509Ce888766305a9065CEC31F5f57446F4194B";

  return {
    JTOKENAddress,
    RANDOMNFTAddress,
    MarketPlaceAddress
  };
};

export default useSharableState;
